import React from "react";
import { Switch } from "react-router-dom";
import * as Loadable from 'react-loadable';
import Loading from './components/Loading';
import AppliedRoute from './components/AppliedRoute';
import AuthenticatedRoute from './components/AuthenticatedRoute';


const AsyncHome = Loadable({
  loader: () => import("./app/Home"),
  loading: Loading
});

const AsyncChess = Loadable({
  loader: () => import("./app/Chess"),
  loading: Loading
});

const AsyncChessForm = Loadable({
  loader: () => import("./app/Chess/gameForm"),
  loading: Loading
});

const AsyncLogin = Loadable({
  loader: () => import("./app/Login"),
  loading: Loading
});

const AsyncAnalysis = Loadable({
  loader: () => import("./app/Chess/analysisChess"),
  loading: Loading
});

const AsyncChessReport = Loadable({
  loader: () => import("./app/Chess/report"),
  loading: Loading
});

const AsyncChessAnalyse = Loadable({
  loader: () => import("./app/Chess/analyse"),
  loading: Loading
});

const AsyncChessImport = Loadable({
  loader: () => import("./app/Chess/import"),
  loading: Loading
});

const AsyncChessLive = Loadable({
  loader: () => import("./app/Chess/live"),
  loading: Loading
});

const AsyncChessManualImport = Loadable({
  loader: () => import("./app/Chess/manualImport"),
  loading: Loading
});

// const AsyncChessNew = Loadable({
//   loader: () => import("./app/Chess/new"),
//   loading: Loading
// });




const AsyncNotFound = Loadable({
  loader: () => import("./app/NotFound/index"),
  loading: Loading
})

export default ({ childProps }) =>
  <Switch>
    <AppliedRoute
      path="/"
      exact
      component={AsyncHome}
      props={childProps}
    />
     {/* <AppliedRoute
      path="/chess/new"
      exact
      component={AsyncChessNew}
      props={childProps}
    /> */}
    <AppliedRoute
      path="/login"
      exact
      component={AsyncLogin}
      props={childProps}
    />
     <AuthenticatedRoute
      path="/chess/new"
      exact
      component={AsyncChessForm}
      props={childProps}
    />
     <AuthenticatedRoute
      path="/chess/import"
      exact
      component={AsyncChessImport}
      props={childProps}
    />
      <AuthenticatedRoute
      path="/chess/manualImport"
      exact
      component={AsyncChessManualImport}
      props={childProps}
    />
     <AppliedRoute
      path="/chess/analysis"
      exact
      component={AsyncAnalysis}
      props={{...childProps, analysisMode:true}}
    />
     <AuthenticatedRoute
      path="/chess/:_id"
      exact
      component={AsyncChess}
      props={childProps}
    />
      <AuthenticatedRoute
      path="/chess/:_id/report"
      exact
      component={AsyncChessReport}
      props={childProps}
    />
      <AuthenticatedRoute
      path="/chess/:_id/analyse"
      exact
      component={AsyncChessAnalyse}
      props={childProps}
    />
     <AuthenticatedRoute
      path="/chess/:_id/live"
      exact
      component={AsyncChessLive}
      props={childProps}
    />
   
    {/* <AppliedRoute
      path="/article/:_id"
      exact
      component={AsyncArticle}
      props={childProps}
    />  */}


     */}
    {/* Finally, catch all unmatched routes */}
    <AppliedRoute component={AsyncNotFound} />
  </Switch>;


// WEBPACK FOOTER //
// ./src/routes.js